import React from 'react';
import './WhySolar.css';

const WhySolar = () => {
  const reasons = [
    {
      icon: 'fas fa-globe-americas',
      title: 'Bảo vệ môi trường toàn cầu',
      description:
        'Chắc chắn là nên lắp điện năng lượng mặt trời. Không chỉ là một nguồn năng lượng sạch đang được khuyến khích trên toàn cầu nhằm giảm phát thải khí nhà kính, chống lại biến đổi khí hậu, bảo vệ môi trường và hệ sinh thái, điện mặt trời mang lại những lợi ích rất thiết thực cho chủ đầu tư.',
    },
    {
      icon: 'fas fa-hand-holding-usd',
      title: 'Tiết kiệm chi phí & sinh lời bền vững',
      description:
        'Điện mặt trời tạo ra điện sạch phục vụ nhu cầu sinh hoạt, giúp các hộ gia đình tiết kiệm đáng kể chi phí điện mỗi tháng và có thêm nguồn thu nhập nhờ bán điện dư. Hệ thống tấm pin năng lượng mặt trời được lắp đặt trên mái còn giúp cách nhiệt cho mái, giảm nhiệt cho ngôi nhà, từ đó giảm công suất tiêu thụ điện của máy lạnh.',
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Đầu tư an toàn, hiệu quả',
      description:
        'Qua tính toán chi tiết khi thiết kế hệ thống điện mặt trời cũng như thực tế tại hàng chục ngàn hộ gia đình tại Việt Nam, điện mặt trời đã tự chứng minh về lợi nhuận kinh tế của mình và được công nhận là một hình thức sinh lời an toàn, hiệu quả.',
    },
  ];

  const stats = [
    {
      icon: 'fas fa-solar-panel',
      value: '25+',
      unit: 'Năm',
      label: 'Tuổi thọ hệ thống',
    },
    {
      icon: 'fas fa-bolt',
      value: '90%',
      unit: '',
      label: 'Tiết kiệm điện năng',
    },
    {
      icon: 'fas fa-calendar-check',
      value: '3-5',
      unit: 'Năm',
      label: 'Hoàn vốn đầu tư',
    },
    {
      icon: 'fas fa-leaf',
      value: '100%',
      unit: '',
      label: 'Năng lượng sạch',
    },
  ];

  return (
    <section id="why-solar" className="why-solar-section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header" data-aos="fade-up">
          <span className="section-tag">TẠI SAO NÊN LẮP?</span>
          <h2 className="section-title">
            CÓ NÊN LẮP ĐIỆN NĂNG LƯỢNG MẶT TRỜI KHÔNG?
          </h2>
          <p className="section-description">
            Tìm hiểu những lý do thuyết phục để đầu tư vào hệ thống điện mặt
            trời cho gia đình và doanh nghiệp của bạn
          </p>
        </div>

        {/* Main Content */}
        <div className="why-solar-content">
          {/* Reasons Cards */}
          <div className="why-solar-reasons">
            {reasons.map((reason, index) => (
              <div
                key={index}
                className="reason-card"
                data-aos="fade-up"
                data-aos-delay={index * 150}
              >
                <div className="reason-icon-wrapper">
                  <div className="reason-icon">
                    <i className={reason.icon}></i>
                  </div>
                  <div className="reason-number">0{index + 1}</div>
                </div>
                <div className="reason-content">
                  <h3 className="reason-title">{reason.title}</h3>
                  <p className="reason-description">{reason.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Diagram / Visual Side */}
          <div className="why-solar-visual" data-aos="fade-left">
            <div className="solar-diagram">
              <div className="diagram-header">
                <i className="fas fa-solar-panel"></i>
                <h4>Sơ đồ hệ thống điện mặt trời</h4>
              </div>
              <div className="diagram-image-wrapper">
                <img
                  src="https://images.unsplash.com/photo-1558449028-b53a39d100fc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                  alt="Sơ đồ hệ thống điện mặt trời"
                  className="diagram-image"
                />
                <div className="diagram-overlay">
                  <div className="diagram-flow">
                    <div className="flow-item">
                      <div className="flow-icon">
                        <i className="fas fa-sun"></i>
                      </div>
                      <span>Ánh sáng</span>
                    </div>
                    <div className="flow-arrow">
                      <i className="fas fa-long-arrow-alt-right"></i>
                    </div>
                    <div className="flow-item">
                      <div className="flow-icon">
                        <i className="fas fa-solar-panel"></i>
                      </div>
                      <span>Tấm pin</span>
                    </div>
                    <div className="flow-arrow">
                      <i className="fas fa-long-arrow-alt-right"></i>
                    </div>
                    <div className="flow-item">
                      <div className="flow-icon">
                        <i className="fas fa-exchange-alt"></i>
                      </div>
                      <span>Inverter</span>
                    </div>
                    <div className="flow-arrow">
                      <i className="fas fa-long-arrow-alt-right"></i>
                    </div>
                    <div className="flow-item">
                      <div className="flow-icon">
                        <i className="fas fa-home"></i>
                      </div>
                      <span>Sử dụng</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Call to action */}
            <div className="why-solar-cta">
              <div className="cta-content">
                <h4>Bạn muốn tìm hiểu chi phí lắp đặt?</h4>
                <p>
                  Liên hệ ngay để được tư vấn miễn phí về bài toán chi phí lắp
                  đặt, thời gian hoàn vốn và sinh lời.
                </p>
              </div>
              <a href="#contact" className="btn-cta-solar">
                <i className="fas fa-phone-alt"></i>
                Tư vấn miễn phí
              </a>
            </div>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="why-solar-stats" data-aos="fade-up">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="stat-item"
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="stat-icon">
                <i className={stat.icon}></i>
              </div>
              <div className="stat-value">
                {stat.value}
                {stat.unit && <span className="stat-unit"> {stat.unit}</span>}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySolar;